import { IDeliveryDropOffCoordinatesHttpDto } from '../../dtos/interfaces';

interface BuildDeliveryRequestContentParams {
  isDeliverySale: boolean;
  deliveryDropOffCoordinates?: IDeliveryDropOffCoordinatesHttpDto;
  existingAddress?: Record<string, unknown>;
  customAddress?: string;
  customSuburb?: string;
  customPostCode?: string;
}

interface DeliveryRequestContent {
  deliverySaleCoordinatesContent: {
    DeliveryDropOffCoordinates?: {
      Latitude?: number;
      Longitude?: number;
    };
  };
  customAddressContent: {
    Address?: {
      StreetName?: string;
      Postcode?: string;
      Suburb?: string;
      [key: string]: unknown;
    };
  };
}

export function buildDeliveryRequestContent({
  isDeliverySale,
  deliveryDropOffCoordinates,
  existingAddress,
  customAddress,
  customSuburb,
  customPostCode,
}: BuildDeliveryRequestContentParams): DeliveryRequestContent {
  const hasDeliveryDropOffCoordinates =
    !!deliveryDropOffCoordinates &&
    Object.keys(deliveryDropOffCoordinates).length > 0;

  const deliverySaleCoordinatesContent =
    isDeliverySale && hasDeliveryDropOffCoordinates
      ? {
          DeliveryDropOffCoordinates: {
            Latitude: deliveryDropOffCoordinates!.latitude,
            Longitude: deliveryDropOffCoordinates!.longitude,
          },
        }
      : {};

  const shouldIncludeCustomAddress =
    isDeliverySale && (customAddress || customSuburb || customPostCode);

  const customAddressContent = shouldIncludeCustomAddress
    ? {
        Address: {
          ...(existingAddress || {}),
          ...(customAddress && { StreetName: customAddress }),
          ...(customPostCode && { Postcode: String(customPostCode) }),
          ...(customSuburb && { Suburb: String(customSuburb) }),
        },
      }
    : {};

  return { deliverySaleCoordinatesContent, customAddressContent };
}
